import { useState } from "react";
import { React } from "react-router-dom";

export default function FlashCards()
{
    const [authorized, setAuthorized] = useState(false);

    return (
      <div>
        <a>Hello World</a>
      </div>
    );
}